import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { playSoundEffect } from '../hooks/useSoundEffects';
import '../BattleUIExploreUnknownDarknessFlash.css';
import './ExploreUnknownRewardPopups.css';

/**
 * First-time boss defeat: grant + reveal one Refined Erray (server: exploreUnknownRefinedErrayBossDrops).
 *
 * @param {{ popupId: string, missionIndex: number, onDismiss: () => void }} props
 */
export default function ExploreUnknownRefinedErrayBossDropModal({ popupId, missionIndex, onDismiss }) {
  const { t } = useTranslation();

  useEffect(() => {
    playSoundEffect('/sounds/slot_erray.mp3');
  }, [popupId]);

  return createPortal(
    <div
      className="battle-eu-heart-set-complete-overlay explore-unknown-reward-popup-overlay"
      onClick={onDismiss}
    >
      <div
        className="battle-eu-heart-set-complete-modal battle-eu-heart-set-complete-modal--rewrite explore-unknown-reward-popup-modal explore-unknown-reward-popup-modal--refined-erray"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="explore-unknown-refined-erray-boss-drop-title"
      >
        <h3
          id="explore-unknown-refined-erray-boss-drop-title"
          className="battle-eu-heart-set-complete-title explore-unknown-reward-popup-refined-erray-title"
        >
          {t('exploreUnknownBattle.refinedErrayBossDropTitle')}
        </h3>
        <div className="battle-eu-heart-set-complete-visual">
          <img
            src="/images/refined_erray.png"
            alt=""
            className="battle-eu-heart-set-complete-image explore-unknown-reward-popup-refined-erray-img"
          />
        </div>
        <p className="battle-eu-heart-set-complete-body">
          {t('exploreUnknownBattle.refinedErrayBossDropBody', { missionIndex })}
        </p>
        <button type="button" className="battle-eu-heart-set-complete-ok" onClick={onDismiss}>
          {t('exploreUnknownBattle.refinedErrayBossDropOk')}
        </button>
      </div>
    </div>,
    document.body
  );
}
